module.exports = __webpack_public_path__ + "img/img-127.118f8208.png";